module.exports = __webpack_public_path__ + "static/media/landing.e2e5c1c1.png";